import { styled } from "@mui/material"

export const StyledLastActive = styled("span")`
  white-space: nowrap;
`
